import PaginatedTable, {
  CustomPaginatedTableProps,
} from '../../ui/table/paginated-table/paginated-table';
import { Column } from '../../ui/table/types';

export type SalesOrdersTableProps<T extends { id: string }> =
  CustomPaginatedTableProps<T> & {
    columns: Column<T>[];
  };

export function SalesOrdersTable<T extends { id: string }>({
  columns,
  dataSource,
  onChange,
  config,
  form,
  empty,
  rowSelection,
  errorMessage,
  children,
}: SalesOrdersTableProps<T>) {
  return (
    <PaginatedTable
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      config={config}
      form={form}
      empty={empty}
      rowKey={'id'}
      rowSelection={rowSelection}
      errorMessage={errorMessage}
      children={children}
    />
  );
}

export default SalesOrdersTable;
